export const classes = {
  count:
    'mr-6 flex items-center gap-2 text-base font-medium text-grey-8 dark:text-mauve-1 rounded-full px-3.5 py-2 bg-grey-2 dark:bg-white/[0.06] hover:bg-grey-3 dark:hover:bg-white/[0.1] transition-colors cursor-pointer',
  countInsufficient:
    'mr-6 flex items-center gap-2 text-base font-medium text-red-4 rounded-full px-3.5 py-2 bg-red-1 hover:bg-red-2 transition-colors cursor-pointer',
  icon: 'text-xl',
  value: 'tabular-nums font-semibold',
  available: 'tabular-nums font-normal opacity-60',
};
